export const API_URL = `${process.env.VUE_APP_API_URL}`;
export const API_KEY = `${process.env.VUE_APP_API_KEY}`;
export const APLICATION_TYPE = `${process.env.VUE_APP_APLICATION_TYPE}`;
export const AUTH_URL = `${process.env.VUE_APP_AUTH_URL}`;